import { AxisLeft, AxisScale } from "@visx/axis"

import { percentanceFormat } from "../../../helpers/formatters"

export type YAxisDataProps = {
  scale: AxisScale
}

export default function YAxis({ scale }: YAxisDataProps) {
  return (
    <AxisLeft
      scale={scale}
      top={50}
      left={75}
      tickStroke="transparent"
      tickFormat={(v) => percentanceFormat(v as number)}
      numTicks={5}
      tickLength={10}
      tickLabelProps={(v) => ({
        fill: v < 0 ? "var(--other-red)" : "white",
        fontSize: "12px",
        textAnchor: "end",
      })}
    />
  )
}
